import src from "IMAGE";
export default { src, width: 406, height: 406, blurWidth: 0, blurHeight: 0};
